module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"dropdown\">\r\n    <button class=\"dropdown-toggle\" type=\"button\" id=\"roledropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\r\n        ")
    ; __append(escapeFn(currentRole))
    ; __append("\r\n        <span class=\"caret\"></span>\r\n    </button>\r\n    <ul class=\"dropdown-menu\" aria-labelledby=\"roledropdown\">\r\n        ")
    ; 
        roles.map(function(role){
        
    ; __append("\r\n        <li><a href=\"#\" class=\"select-role\" data-role-id=\"")
    ; __append(escapeFn(role.id))
    ; __append("\">")
    ; __append(escapeFn(role.name))
    ; __append("</a></li>\r\n        ")
    ; 
        });
        
    ; __append("\r\n    </ul>\r\n</div>")
  }
  return __output;

}